import PolicyPage from '@/components/pageEditor/PolicyPage';

// المحتوى من قاعدة البيانات (صفحات الموقع) ويتعدّل من الواجهة للأدمن
const PrivacyPolicy = () => <PolicyPage slug="privacy" />;

export default PrivacyPolicy;
